module.exports = __webpack_public_path__ + "kalender.svg?1bd6e2494cd3142328eda26c33e201a5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/kalender.svg
// module id = 550
// module chunks = 0